import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Commitments } from "@/components/site/Commitments";
import { Marquee } from "@/components/site/Marquee";
import { EnterpriseAIGap } from "@/components/site/EnterpriseAIGap";
import { Pillars } from "@/components/site/Pillars";
import { Functions } from "@/components/site/Functions";
import { DataSolutions } from "@/components/site/DataSolutions";
import { CaseStudies } from "@/components/site/CaseStudies";
import { Leadership } from "@/components/site/Leadership";
import { Continuation, Footer } from "@/components/site/Continuation";
import { ContactDialog } from "@/components/site/ContactDialog";

export default function Home() {
  const [contactSource, setContactSource] = useState(null);

  return (
    <div className="bg-[#F7F5F0] min-h-screen text-left">
      <div className="grain" />
      <Navbar onContact={setContactSource} />
      <main>
        <Hero onContact={setContactSource} />
        <Marquee />
        <Commitments />
        <Pillars />
        <EnterpriseAIGap />
        <Functions />
        <DataSolutions onContact={setContactSource} />
        <CaseStudies />
        <Leadership />
        <Continuation onContact={setContactSource} />
      </main>
      <Footer onContact={setContactSource} />
      <ContactDialog source={contactSource} onClose={() => setContactSource(null)} />
    </div>
  );
}
